"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var cssesc_1 = __importDefault(require("cssesc"));
var escapeCss = function (value) {
    if (value) {
        if (typeof value === "number") {
            return cssesc_1.default(String(value));
        }
        if (typeof value === "string") {
            return cssesc_1.default(value);
        }
    }
    return undefined;
};
exports.default = escapeCss;
//# sourceMappingURL=index.js.map